// NOTICE!! THIS IS REQUIRED TO MAKE YOUR NETO SHOPPING CART WORK
// DO NOT REMOVE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING

var nCustom = {
  vars: {
    focused: $('body'),
    lastFocused: $('body'),
  },
  funcs: {
    initPageFuncs: function () {
      // Ajax Wish List
      $.addToWishList({
        class: 'wishlist_toggle',
        textclass: 'wishlist_text',
        htmlon: '<svg><use xlink:href="#icon-heart"></use></svg>',
        htmloff: '<svg><use xlink:href="#icon-heart"></use></svg>',
        tooltip_css: 'whltooltips',
        imageon: '',
        imageoff: '',
      });
      // Ajax Add To Cart
      $.addToCartInit({
        cart_id: 'cartcontents',
        target_id: 'cartcontentsheader',
        image_rel: 'itmimg',
      });
      // Renders the instant search results - edit design of ajax results here
      if (currentpage == '1020') {
        $('input#name_search').keydown(function (e) {
          if (e.keyCode == 13) { // enter key was pressed
            // run own code
            return false; // prevent execution of rest of the script + event propagation / event bubbling + prevent default behaviour
          }
        });

        $.initSearchField({
          'result_header': '<ul class="nav nav-list quick-buy">',
          'result_body': '<li class="quick-search__item" id="##SKU##"><form class="form-inline buying-options"> <input type="hidden" id="sku##rndm####SKU##" name="sku##rndm####SKU##" value="##SKU##"> <input type="hidden" id="model##rndm####SKU##" name="model##rndm####SKU##" value="##model##"> <input type="hidden" id="thumb##rndm####SKU##" name="thumb##rndm####SKU##" value="##thumb##"><div class=" quick-search__item-wrap"><div class="quick-img__holder"><div class="thumb"><img border="0" src="##thumb##" width="50" height="50"/></div></div><div class=" quick-item-name__holder"><div class="quick-buy__title-wrap"><p class="quick-buy__title">##model## </p><p class="quick-buy__sku">SKU: ##sku##</p></div></div><div class=" quick-buy-price__holder"><div class="quick-buy-price">$##price##</div></div><div class=" quick-buy-btn__holder"><div class="quick-buy-btn"><input type="text" id="qty##rndm####SKU##" name="qty##rndm####SKU##" value="1" class="quick-buy-qty"><button type="button" title="Add to Cart" class="addtocart btn  btn-loads " rel="##rndm####SKU##">Add to Cart</button><div class="clearfix"></div></div></div></form></li>',
          'extact_body': '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
          'result_footer': '</ul>',
          'category_header': '<ul class="nav nav-list">',
          'category_body': '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
          'category_footer': '</ul>',
          'include_price': true
        });
      } else {
        $.initSearchField({
          'result_header': '<ul class="nav nav-list">',
          'result_body': '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
          'result_footer': '</ul>',
          'category_header': '<ul class="nav nav-list">',
          'category_body': '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
          'category_footer': '</ul>'
        });
      }
    },
    // For child product multi-add to cart function
    checkValidQty: function () {
      // var found = 0;
      // $('#multiitemadd :input').each(function() {
      // 	if ($(this).attr('id').match(/^qty/)) {
      // 		if ($(this).val() > 0) {
      // 			found = 1;
      // 		}
      // 	}
      // });
      // if (found == 0) {
      // 	$.nPopupBox('Please specify a quantity before adding to cart');
      // 	return false;
      // }
      return true;
    },
    // Capture the last item focused
    updateFocused: function () {
      nCustom.vars.lastFocused = nCustom.vars.focused;
    },
    // Place focus on popup
    popupFocus: function () {
      var popUp = document.getElementById('npopupDesc');
      // Configures the observer
      var config = { childList: true };
      // Create an observer instance
      var popUpObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // Initial observer
          if (mutation.addedNodes['0']) {
            nCustom.funcs.updateFocused();
            // focus on the popup
            $(popUp).attr('tabindex', '-1').trigger('focus');
          } else {
            $(popUp).attr('tabindex', '').trigger('focus');
            // Observer closing popup
            $(nCustom.vars.lastFocused).trigger('focus');
          }
        });
      });
      // Pass in the target node, as well as the observer options
      if (popUp) {
        popUpObserver.observe(popUp, config);
      }
    },
    buttonLoading: function () {
      var loadingText = $(this).attr('data-loading-text');
      var originalText = $(this).html();
      $(this).html(loadingText).addClass('disabled').prop('disabled', true);
      var pendingButton = this;
      setTimeout(function () {
        $(pendingButton)
          .html(originalText)
          .removeClass('disabled')
          .prop('disabled', false);
      }, 3000);
    },
    windowPopup: function (url, width, height) {
      // Calculate the position of the popup so it’s centered on the screen.
      var left = screen.width / 2 - width / 2,
        top = screen.height / 2 - height / 2;
      window.open(
        url,
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
        width +
        ',height=' +
        height +
        ',top=' +
        top +
        ',left=' +
        left,
      );
    },
    // Will remove/add class from element
    classToggle: function (element, css, type) {
      if (type) {
        type == 'add' ? $(element).addClass(css) : $(element).removeClass(css);
      }
    },
  },
};




$(document).ready(function () {
  // Neto functionalty
  nCustom.funcs.initPageFuncs();
  nCustom.funcs.popupFocus();
  // Jquery Ui Date Picker
  $('.datepicker').datepicker({ dateFormat: 'dd/mm/yy' });
  // Carousel
  $('.carousel').carousel();
  // Tooltip
  $('[data-toggle="tooltip"]').tooltip();
});
// Capture the current element the user focused in
$(document).on('focusin', function () {
  nCustom.vars.focused = document.activeElement;
});
// Btn loading state
$(document).on('click', '.btn-loads', nCustom.funcs.buttonLoading);
// Social media share
$('.js-social-share').on('click', function (e) {
  e.preventDefault();
  nCustom.funcs.windowPopup($(this).attr('href'), 500, 300);
});
// Mobile menu
$('.nToggleMenu').on('click', function () {
  var toggleTarget = $(this).attr('data-target');
  $(toggleTarget).slideToggle();
});
// Invoice page
$('#cart_items').on('click', '[data-body-add]', function (e) {
  e.preventDefault();
  nCustom.funcs.classToggle('body', $(this).attr('data-body-add'), 'add');
});
$('#cart_items').on('click', '[data-body-remove]', function (e) {
  e.preventDefault();
  nCustom.funcs.classToggle('body', $(this).attr('data-body-remove'), 'remove');
});
$('#_jstl__buying_options').on(
  'click',
  '.js-notifymodal-in-stock',
  function (e) {
    e.preventDefault();
    // Get values
    var sku = $(this).attr('data-sku');
    var $wrapper = $('#notifymodal .checkbox');
    var $terms = $('#notifymodal .terms_box');
    var $helpText = $('#notifymodal .checkbox .help-block');
    // Validate form
    if (!$.isChecked($terms)) {
      $wrapper.addClass('has-error');
      $helpText.removeClass('hidden');
      return false;
    } else {
      $wrapper.removeClass('has-error');
      $helpText.addClass('hidden');
      // Dismiss modal
      $('#notifymodal').modal('hide');
      // Send information
      $.addNotifyBackInStock(sku, '');
      $terms.attr('checked', false);
      return true;
    }
  },
);
// Multi add child products
$('.multi-add').on('click', function () {
  $.addMultipleCartItems('multiitemadd');

  return false;
});

$(document).ready(function () {
  $.compatListInit({});
  $(".compatibility_list").change(function () {
    $.buildCompatList($(this));
  });
})




// Update Order Summary on Add to Cart

nAddItemCallbacks.push(updateOrderSummary, cartLoaded);
nAddMultiItemsCallbacks.push(updateOrderSummary);
nRemoveItemCallbacks.push(updateOrderSummary);


function cartLoaded() {
  if (currentpage == '1020') {
    const popup = document.querySelector('.npopup');
    const cartMenu = document.getElementById('jsCartWrap');
    popup.classList.add('d-none');
    if (window.innerWidth > 1200) {
      cartMenu.classList.add('activeClass');
    }
  }
}


// Update Order Summary
function updateOrderSummary() {
  $.load_ajax_template('_order_summary', {});
}


if (currentpage == '1020') {

  (o = jQuery).extend({
    initSearchField: function (e) {
      e = o.soap_default_data(e, {
        class: "ajax_search",
        "pl-class": "nsearchinput-pl",
        "extra-pl-class": "well",
        "title-class": "title",
        "min-length": 1,
        "load-time": 800,
        result_header: "<ul>",
        extact_body: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="25px" height="25px"/></span><span class="title">##model##</span></a></li>',
        result_body: '<li><a href="javascript:void(0);" search-keyword="##keyword##"><span class="thumb"><img border="0" src="##thumb##" width="25px" height="25px"/></span><span class="title">##model##</span></a></li>',
        result_footer: "</ul>",
        category_header: "<ul>",
        category_body: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="25px" height="25px"/></span><span class="title">##fullname## - ##typename##</span></a></li>',
        category_footer: "</ul>",
        search_category: !1,
        include_price: !1,
        always_exact: !1,
        debug: !1,
        fns: {},
        showparam: !1,

      }),
        // o("html").on("click", function(t) {
        // 	o("." + e["pl-class"]).hide()
        // }),
        o("." + o.escape_reserved(e.class)).each(function () {
          var t = o(this).attr("nsearch-init");
          if ("string" != typeof t || "yes" != t) {
            o(this).attr("nsearch-init", "yes");
            var a = NESearchTimers.length;
            NESearchTimers.push(null),
              o(this).attr("nsearch-id", a),
              o(this).on("keyup", function () {
                var t = o(this),
                  s = parseInt(o(this).attr("nsearch-id"));
                if (!isNaN(s)) {
                  var i = o(this).prevAll("." + o.escape_reserved(e["pl-class"]) + '[nsearch-id="' + s + '"]:last');
                  i.length <= 0 && ((i = o('<div class="' + e["pl-class"] + " " + e["extra-pl-class"] + '" nsearch-id="' + a + '"></div>').hide()).css("margin-top", o(this).height() + 10 + "px"),
                    o(this).before(i)),
                    null !== NESearchTimers[s] && clearTimeout(NESearchTimers[s]);
                  var n = o.trim(o(this).val()),
                    r = {
                      keyword: n,
                      category: e.search_category ? "y" : "n",
                      price: e.include_price ? "y" : "n"
                    };
                  n.length > e["min-length"] && (0 == t.prev("img.search_loading_icon:last").length ? t.before('<img class="search_loading_icon" src="/assets/loading.gif"/>') : t.prev("img.search_loading_icon:last").show(),
                    NESearchTimers[s] = setTimeout(function () {
                      o.do_ajax("ajax_search", r, !0, {
                        SUCCESS: {
                          def: {
                            results: [],
                            category: []
                          },
                          fn: function (a, s) {
                            if (0 == s.results.length && 0 == s.category.length)
                              t.prev("img.search_loading_icon:last").hide(),
                                i.hide();
                            else {
                              var r = "";
                              if (s.results.length > 0) {
                                /* sort search results by sku */
                                function compare(a, b) {
                                  if (a.sku < b.sku)
                                    return -1;
                                  if (a.sku > b.sku)
                                    return 1;
                                  return 0;
                                }
                                s.results.sort(compare);
                                /* end sort */
                                r += o.parse_ntemplate(e.result_header);
                                for (var c = 1 == s.results.length, l = 0; l < s.results.length; l++) {
                                  var d = s.results[l];
                                  c || e.always_exact ? (d.keyword = d.sku,
                                    r += o.parse_ntemplate(e.extact_body, d)) : (d.keyword = d.model.replace(/&quot;/gi, ""),
                                      r += o.parse_ntemplate(e.result_body, d))
                                }
                                r += o.parse_ntemplate(e.result_footer)
                              }
                              if (s.category.length > 0) {
                                for (r += o.parse_ntemplate(e.category_header),
                                  l = 0; l < s.category.length; l++)
                                  d = s.category[l],
                                    r += o.parse_ntemplate(e.category_body, d);
                                r += o.parse_ntemplate(e.category_footer)
                              }
                              i.html(r),
                                i.find("A[search-keyword]").each(function () {
                                  for (var a = o(this).find("." + o.escape_reserved(e["title-class"])), s = a.html(), r = n.split(/\s+/), c = 0; c < r.length; c++)
                                    r[c].replace(/[<>]+/, ""),
                                      r[c].length > 1 && (s = s.replace(new RegExp("(" + o.escape_reserved(r[c]) + ")", "gi"), "<b>$1</b>"));
                                  a.html(s),
                                    o(this).on("click", function () {
                                      t.val(o(this).attr("search-keyword")),
                                        i.hide(),
                                        o(this).closest("FORM").trigger("submit")
                                    })
                                }),
                                t.prev("img.search_loading_icon:last").hide(),
                                i.show()
                            }
                          }
                        },
                        FAIL: {
                          def: {
                            msg: ""
                          },
                          fn: function (e, a) {
                            t.prev("img.search_loading_icon:last").hide(),
                              i.hide()
                          }
                        },
                        ERROR: {
                          def: {
                            msg: ""
                          },
                          fn: function (e, a) {
                            t.prev("img.search_loading_icon:last").hide(),
                              i.hide()
                          }
                        }
                      }, "GET")
                    }, e["load-time"]))
                }
              })
          }
        })



    }
  });

};


$(document).ready(function () {

  var f = $('.vidhov').first();
  if (f[0] != null) {
    var playPromise = f[0].play();
    if (playPromise !== undefined) {
      playPromise.then(_ => { }
      ).catch(error => { }
      );
    }
  }
  $(f).addClass('simulate-hover');

  $(document).on({
    mouseenter: function () {
      $('.simulate-hover').removeClass('simulate-hover');
      var playPromise = this.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => { }
        ).catch(error => { }
        );
      }
    },
    mouseleave: function () {
      this.pause();
    }
  }, ".vidhov");


});